module.exports = __webpack_public_path__ + "static/media/zoleWon_5000_10000.c46d3d8d.png";